import {useEffect} from 'react';
import {setDimensionToGA4} from 'app/helpers/gtagHelpers';
import {useNative} from 'app/contexts/NativeContext';

const usePlatformUserPropertyForGoogleAnalytics = () => {
  const {isNativeApp, platform} = useNative();

  useEffect(() => {
    let app = 'false';
    if (isNativeApp) {
      app = platform;
    }
    const ga4Platform = app === 'false' ? 'web' : app;
    setDimensionToGA4({user_properties: {fupa_platform: ga4Platform}});
  }, [isNativeApp, platform]);
};

export default usePlatformUserPropertyForGoogleAnalytics;
